module.exports = __webpack_public_path__ + "img/L5.db3c8f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cooperation/banner/L5.png
// module id = KkP3
// module chunks = 0